// extracted by css-extract-rspack-plugin
export default {"resultItem":"ZFekL"};